export default {
  website: {
    shoutoutSliderText1:
      'Streaming di partite di Ligue 1, Serie A, Bundesliga, Premier Ligue, NFL, NBA, NCAA e molte altre!',
    'shoutout!': 'Shoutout!',
    loveTheGame: 'AMA IL GIOCO. FALLO TUO.',
    joinTheDedicated:
      'Entra a far parte del social network dedicato allo sport, un ecosistema che si rafforza grazie agli sponsor ed ai partner.',
    aSportsCommunity: 'Un nuovo marketplace per la community sportiva.',
    athletesMonetize: 'Gli atleti monetizzano il loro brand.',
    fansConnectDirectly: 'I tifosi si connettono direttamente con gli atleti.',
    ledByAthletes: 'GUIDATI DAGLI ATLETI.',
    ledByFans: 'GUIDATI DAI FAN.',
    ledBy: 'GUIDATO DA',
    'athletes.': 'ATLETI.',
    'fans.': 'TIFOSI.',
    goToApp: "Vai all'APP",
    logout: 'Disconnettersi',
    amAnAthlete: 'Sono un atleta',
    monetizeYourBrand: 'Monetizza il tuo brand creando un mondo unico con i tuoi tifosi.',
    amAFan: 'Sono un tifoso',
    connectDirectlyWith:
      'Connettiti direttamente con i tuoi atleti preferiti e con gli altri tifosi',
    athleteZone: "ZONA DELL' ATLETA",
    fanZone: 'FAN ZONE',
    ourAthletes: 'I NOSTRI ATLETI',
    news: 'Notizie',
    ourStory: 'LA NOSTRA STORIA',
    sponsors: 'SPONSOR',
    contact: 'CONTATTO',
    athleteFocus: "Focus sull'Atleta",
    calculator: 'Calcolatrice',
    seeHowMuch: 'Scopri quanto potrebbe farvi guadagnare il tuo marchio.',
    weAllPlay: 'GIOCHIAMO TUTTI MEGLIO INSIEME.',
    everybody: 'TUTTI',
    playsBetter: 'GIOCA MEGLIO',
    weAll: 'TUTTI NOI',
    playBetter: 'GIOCA MEGLIO',
    together: 'INSIEME.',
    video: 'Video',
    tiffanyVan: 'Tiffany Van Soest',
    goto: 'Vai a',
    athleteZoneSmall: "Zona dell'Atleta",
    latestNews: 'ULTIME NOTIZIE',
    ledByPartners: 'GUIDATO DAI PARTNER.',
    partnersAndSponsors: 'Partner e sponsor',
    ledByTeams: 'Guidato dalle squadre.',
    seeOurWork: 'Guarda il nostro lavoro con questi atleti di punta',
    sportsCareer:
      'La carriera sportiva può essere breve, ma hai acquisito una grande esperienza. Ora è il momento di raccogliere i frutti.,',
    buildAnOngoing: 'Costruisci un reddito continuo e sostenibile.,',
    takeControl: 'Prendi il controllo del tuo brand e del tuo futuro.,',
    signUpForFree:
      'Iscriviti gratuitamente per calcolare quanto la tua carriera può continuare a farti guadagnare.,',
    'connect!': 'Collegati!',
    unlimitedAccess:
      'Accesso illimitato ai tuoi atleti preferiti. Costruisci la tua rete di eroi dello sport!',
    'stream!': 'Trasmetti!',
    streamGamesFrom:
      'Streaming di partite di Ligue 1, Serie A, Bundesliga, Premier Ligue, NFL, NBA, NCAA e molte altre!',
    stayVisible: 'RIMANI VISIBILE',
    connectWithUs: 'Connettiti con noi',
    newsletter: 'Newsletter',
    typeEmail: "Digita qui l'email e premi invio",
    typeAndEnter: "Digita qui l'email e premi invio",
    wedLoveTo: 'Saremo lieti di ascoltarti.',
    sendUsAMessage: 'Inviaci un messaggio',
    notAnAthleteOrFan: 'Non sei un atleta nè un tifoso?',
    connectWithUsHere: 'Collegati comunque con noi qui!',
    home: 'Home',
    fanZoneSmall: 'Fan Zone',
    ourStorySmall: 'La nostra storia',
    ourAthletesSmall: 'I nostri atleti',
    selectCountry: 'Seleziona il paese',
    signUp: 'Iscriviti',
    stopTheHate: "Stop all'Odio",
    termsAndConditions: 'Termini e condizioni',
    privacyPolicy: 'Informativa sulla privacy',
    playaz4playaz: '@playaz4playaz',
    allRigthsReserved: 'Tutti i diritti riservati',
    led: 'LED',
    byTopAthletes: 'DA ATLETI DI ALTO LIVELLO',
    partners: 'Partner',
    investors: 'Investitori',
    attendees: 'Partecipanti',
    date: '26-29 aprile',
    location: 'Wesley Chapel, Florida',
    dontMiss: 'DA NON PERDERE',
    outOn: 'FUORI SU',
    your: 'TUO',
    timeToShine: 'TEMPO DI RISPLENDERE',
    registerForCombine: 'Registrati per Combinare',
    registrationEnds: 'LA REGISTRAZIONE TERMINA',
    days: 'Giorni',
    hours: 'Ore',
    minutes: 'Minuti',
    seconds: 'Secondi',
    ourPartners: 'I NOSTRI PARTNER.',
    enjoyTheseMembership: 'Approfitta di queste incredibili funzioni riservate agli abbonati',
    sportUnites: 'LO SPORT UNISCE',
    noDivide: 'NESSUNA DIVISIONE.',
    videosArticles: 'Video, articoli e interviste alle star dello sport',
    instantMessaging: 'Messaggistica istantanea con i tuoi atleti preferiti',
    discountOnEvent: 'Sconti sui biglietti per gli eventi e sul merchandising',
    behindTheScenes: 'Accesso dietro le quinte al mondo dello sport',
    experienceSport: 'VIVI LO SPORT NEL MODO IN CUI LO AMI',
    theOnlySportsApp:
      "L'unica APP sportiva che ti permette di entrare in contatto diretto con i tuoi atleti preferiti, in tempo reale!",
    buildYourOwnWorld:
      'Costruisci il tuo mondo collegandoti direttamente con gli atleti - il vero affare',
    chooseTheFeatures: 'Scegli le funzioni che più ti piacciono.',
    interactWithAthletes: 'Interagisci con gli atleti e lasciati ispirare!',
    sendAShoutout:
      'Invia un messaggio al tuo atleta o alla tua squadra prima o durante la partita!',
    fanLife: '#FANLIFE',
    highlights: 'Highlights',
    recentArticles: 'Articoli recenti',
    p4pxIra: 'p4p x Ira Brown',
    uploadedDate: 'Caricato il 28 febbraio 2022',
    youMightAlso: 'Ti potrebbe interessare anche...',
    'subscribe!': 'Abbonati!',
    getContent:
      'Ottieni contenuti e streaming per il tuo sport preferito o per tutti gli sport su playaz4playaz!',
    'vipConnects!': 'Collegamenti VIP!',
    '1-to-1connections':
      'Collegamenti uno-a-uno con il tuo atleta preferito, sia virtualmente che di persona!',
    watch: 'Guarda: la storia di p4p',
    caseStudies: 'Casi studio',
    aboutHenrySeals:
      "Laureato all'Università di Harvard, Henry è un esperto di leadership. Attualmente Henry è CHRO di Zaiko, una startup con sede in Giappone che supporta i creatori nel coinvolgere i loro fan attraverso il coinvolgimento digitale e ibrido.  È anche il primo commissario per i diritti umani nato all'estero in Giappone e il fondatore della Legacy Foundation Japan. In qualità di CHRO di Paidy, ha aiutato l'azienda a diventare uno degli unici unicorni giapponesi (aziende con una valutazione di un miliardo di dollari) e a quotarsi in borsa nel 2021.\nHa inoltre ricoperto posizioni di responsabilità nell'ambito delle risorse umane per Philip Morris International, AIG e NN.",
    aboutHoustonRoss:
      "Houston ha un'esperienza pluriennale alla guida di organizzazioni internazionali per prepararsi al futuro, modernizzare le operazioni e le infrastrutture e sviluppare i team per ottenere prestazioni di alto livello.  Più di recente Houston è stato il CTO dell'unicorno giapponese BNPL Paidy, guidando l'organizzazione verso un lancio pubblico di successo.\nLeader globale, Houston ha ricoperto il ruolo di CTO per organizzazioni finanziarie internazionali come AXA Life, ING e NN.  \nAppassionato di sport, intende sfruttare la sua esperienza in ambito tecnologico, finanziario e di eccellenza operativa per fare di P4P un leader globale.",
    aboutJuliusGoldsmith:
      'Julius è un avvocato con oltre 20 anni di esperienza a Wall St. nelle aree dello sviluppo aziendale, dello sviluppo di nuovi prodotti e delle transazioni transfrontaliere. Julius ha lavorato a New York, Londra, Singapore e Tokyo, dove ha maturato una vasta esperienza in diverse aree di competenza, tra cui sviluppo aziendale, finanza, questioni legali e fiscali.  Julius è membro del consiglio del Silberman College of Business della Fairleigh Dickinson University (sua alma mater) ed è anche titolare di un CPA.  ',
    aboutMarcelVanDruten:
      "Marcel Van Druten è un professionista con una comprovata esperienza in contesti tecnologici internazionali. Nato e cresciuto ad Amsterdam, nei Paesi Bassi, fino all'età di 21 anni Marcel ha giocato attivamente a calcio come tenace difensore nei più alti campionati dilettantistici presso vari club calcistici. \nSfruttando la sua profonda esperienza nel campo del marketing e della pubblicità, Marcel ha aiutato marchi internazionali a sviluppare e implementare programmi e iniziative volte ad aumentare i ricavi e a promuovere la consapevolezza del marchio. Poliglotta in inglese, olandese e tedesco e con una grande passione per le arti marziali, il golf e la formula 1, Marcel sta aiutando P4P a diventare la migliore appicazione sportiva del mondo.\n",
    aboutMichaelAJacobs:
      "Michael è un dirigente di alto livello con competenze di tipo giuridico e varie esperienze di successo nel miglioramento di operazioni multi-sito attraverso un forte impegno nella comunità, nelle risorse umane, nei rapporti di lavoro e con i dipendenti e nell'esperienza giuridica.  Attualmente è docente presso la New York University, Robert F. Wagner Graduate School of Public Service e professore associato aggiunto presso la City University of New York, School of Professional Studies.  In precedenza, Michael è stato docente aggiunto presso la University of Maryland Global Campus (ex University of Maryland University College) e la Howard University School of Law. \n",
    aboutMichaelJackson:
      "Laureato alla Columbia University, Michael è un Responsabile di Prodotto di grande esperienza ed ha ricoperti ruoli di rilievo all'interno di organizzazioni internazionali di asset e wealth management.  Ha maturato anni di esperienza nella realizzazione di progetti internazionali volti a migliorare l'efficienza operativa e la fornitura di servizi\/prodotti. \n \n",
    sponsorsSmall: 'Sponsor',
    becomeASponsor: 'DIVENTA SPONSOR DI P4P',
    content1: 'Lorem ipsum...',
    content2: 'Lorem ipsum...',
    ourTeams: 'LE NOSTRE SQUADRE',
    paymentDetails: 'DETTAGLI DI PAGAMENTO',
    cancelWithin30Days:
      'Se si annulla entro 30 giorni, la carta non verrà addebitata. Potrai comunque accedere alle funzioni di base.',
    cardNumber: 'NUMERO DELLA CARTA',
    expiry: 'SCADENZA',
    cvc: 'CVC',
    illDoItLater: 'Lo farò più tardi',
    submit: 'Invia',
    athleteInformation: "INFORMAZIONI SULL'ATLETA",
    contactInformation: 'INFORMAZIONI DI CONTATTO',
    otherInformation: 'ALTRE INFORMAZIONI',
    dateOfBirth: 'DATA DI NASCITA',
    year: 'Anno',
    month: 'Mese',
    day: 'Giorno',
    socialNetworks: 'SOCIAL NETWORK',
    Instagram: 'Instagram',
    facebook: 'Facebook',
    twitter: 'Twitter',
    uploadHeadshot: 'Carica una foto in primo piano o un tiro a canestro',
    phoneNumber: 'Numero di telefono',
    sport: 'Sport',
    linkInstagram: 'Link al vostro profilo Instagram',
    linkFacebook: 'Link al vostro profilo Facebook',
    linkTwitter: 'Link al vostro profilo Twitter',
    athleteSignUp: "Iscrizione dell'atleta",
    thankYou: 'GRAZIE',
    youWillBeSent: "Riceverai a breve un'email di conferma.",
    getTheApp: "INSTALLA L'APP!",
    or: 'O',
    continueOnWebsite: 'Continua sul sito web',
    welcome: 'BENVENUTO!',
    '30dayFull': 'Accesso completo per 30 giorni!',
    enjoyTheseAmazing:
      'Usufruisci di queste incredibili funzioni gratuitamente, senza alcun vincolo!',
    yesGiveMe: "Sì, datemi l'accesso gratuito!",
    noThanksKeep: 'No, grazie, semplifichiamo',
    letsWorkTogether: 'Lavoriamo insieme! Inserisci i tuoi dati e ti contatteremo.',
    yourDetails: 'I VOSTRI DETTAGLI',
    firstName: 'Nome',
    lastName: 'Cognome',
    emailAddress: 'Indirizzo email',
    companyInformation: 'INFORMAZIONI AZIENDALI',
    companyName: "Nome dell'Azienda",
    companyWebsite: 'Sito web aziendale',
    login: 'Accedi',
    getApp: "Installa l'APP",
    letsTalk: 'Parliamo',
    sponsor: 'Sponsor',
    useTheApp: "Utilizza l'APP",
    messageSent: 'Messaggio inviato con successo.',
    invalidEmail: 'Email non valida.',
    addedToNewsletter: "L'email è stata aggiunta con successo alla newsletter",
    recently: 'Recentemente'
  }
};
